import { WebCryptoPort } from "../identity/webcrypto-crypto-port.js";
import { registerServiceWorkerRuntime, } from "./service-worker-runtime.js";
export function hostBrowserServiceWorker(scope, config) {
    const workerScope = scope;
    const runtimeConfig = {
        ...(config.backgroundSyncTag === undefined ? {} : { backgroundSyncTag: config.backgroundSyncTag }),
        cacheStorage: workerScope.caches,
        claimClients: async () => await workerScope.clients.claim(),
        fetch: workerScope.fetch.bind(workerScope),
        onBackgroundSync: async () => {
            const clients = await workerScope.clients.matchAll({ includeUncontrolled: true, type: "window" });
            for (const client of clients)
                client.postMessage({
                    tag: config.backgroundSyncTag,
                    type: "client-node.background-sync",
                });
        },
        ...(config.releaseManifestGate === undefined
            ? {}
            : { releaseManifestGate: toRuntimeReleaseManifestGate(config.releaseManifestGate) }),
        shellAssets: config.shellAssets,
        shellVersion: config.shellVersion,
        skipWaiting: () => workerScope.skipWaiting(),
    };
    registerServiceWorkerRuntime(workerScope, runtimeConfig);
}
function toRuntimeReleaseManifestGate(config) {
    return {
        allowedChannels: config.allowedChannels,
        crypto: new WebCryptoPort(),
        currentProtocolVersion: config.currentProtocolVersion,
        currentStorageSchemaVersion: config.currentStorageSchemaVersion,
        manifestUrl: config.manifestUrl,
        trustedPublicKeys: config.trustedPublicKeys.map((key) => ({
            keyId: key.keyId,
            publicKey: hexToBytes(key.publicKeyHex),
        })),
    };
}
function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Number.parseInt(hex.slice(index * 2, index * 2 + 2), 16);
    }
    return bytes;
}
export async function registerBrowserServiceWorker(url) {
    if (!("serviceWorker" in globalThis.navigator))
        return "unsupported";
    try {
        await globalThis.navigator.serviceWorker.register(url, { scope: "/" });
        return "registered";
    }
    catch {
        return "failed";
    }
}
export function listenBrowserServiceWorkerMessages(listener) {
    if (!("serviceWorker" in globalThis.navigator))
        return () => undefined;
    globalThis.navigator.serviceWorker.addEventListener("message", listener);
    return () => globalThis.navigator.serviceWorker.removeEventListener("message", listener);
}
export async function registerBrowserBackgroundSync(tag = "node-client-sync") {
    if (!("serviceWorker" in globalThis.navigator))
        return false;
    try {
        const registration = await globalThis.navigator.serviceWorker.ready;
        const sync = registration.sync;
        if (sync === undefined)
            return false;
        await sync.register(tag);
        return true;
    }
    catch {
        return false;
    }
}
export async function reportBrowserShellHealthy(assetUrl) {
    if (!("serviceWorker" in globalThis.navigator))
        return;
    try {
        const registration = await globalThis.navigator.serviceWorker.ready;
        registration.active?.postMessage({
            assetUrl,
            type: "shell.health-confirmed",
        });
    }
    catch {
        // Registration status is already rendered by the composition root.
    }
}
//# sourceMappingURL=browser-service-worker.js.map